import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Icon } from 'components/Ui';
import RichText from 'components/RichText';
import {
  fetchEntryByTitle,
  fetchJSONDataByTitle,
} from 'containers/Landing/actions';
import {
  selectEntry,
  selectHasCutoffBranch,
} from 'containers/Landing/selectors';
import { selectIsPartiallyMigrated } from 'containers/Authentication/selectors';
import styles from './styles.scss';

const PlannedMsg = ({ content }) => (
  <div className={styles.alertBanner}>
    <RichText richText={content} />
  </div>
);

const CutoffMsg = ({ content }) => (
  <div className={styles.alertBanner}>
    <RichText richText={content} />
  </div>
);

const PartiallyMigratedMsg = ({ content, onClick }) => (
  <div className={styles.alertBanner}>
    <RichText richText={content} />
    <Button
      text="View Addresses"
      onClick={onClick}
      className={styles.alertBtn}
      icon={<Icon icon="exclamation-triangle" className={styles.icon} />}
      iconPosition="left"
    />
  </div>
);

const MigrationAlert = ({ onClick }) => {
  const isPartiallyMigrated = useSelector(selectIsPartiallyMigrated());
  const hasCutoffBranch = useSelector(selectHasCutoffBranch());
  const msgCutoff = useSelector(selectEntry('xferMsgCutoff'));
  const msgPlanned = useSelector(selectEntry('xferMsgPlanned'));
  const alertPartial = useSelector(selectEntry('xferAlertPartial'));
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      fetchJSONDataByTitle({
        title: 'Customer Migration Config',
        key: 'cutoffBranches',
      }),
    );
  }, []);

  useEffect(() => {
    if (!isPartiallyMigrated && !hasCutoffBranch) return;

    if (hasCutoffBranch) {
      if (isPartiallyMigrated) {
        dispatch(
          fetchEntryByTitle({
            type: 'textRich',
            title: 'Acct Xfer > Cutoff Message',
            key: 'xferMsgCutoff',
          }),
        );
      } else {
        dispatch(
          fetchEntryByTitle({
            type: 'textRich',
            title: 'Acct Xfer > Planned Message',
            key: 'xferMsgPlanned',
          }),
        );
      }

      return;
    }

    if (isPartiallyMigrated) {
      dispatch(
        fetchEntryByTitle({
          type: 'textRich',
          title: 'Acct Xfer > Partial Alert',
          key: 'xferAlertPartial',
        }),
      );
    }
  }, [hasCutoffBranch, isPartiallyMigrated]);

  if (!isPartiallyMigrated && !hasCutoffBranch) return null;

  if (hasCutoffBranch) {
    if (isPartiallyMigrated) return <CutoffMsg content={msgCutoff} />;
    return <PlannedMsg content={msgPlanned} />;
  }

  return <PartiallyMigratedMsg content={alertPartial} onClick={onClick} />;
};

export default MigrationAlert;
